module.exports = __webpack_public_path__ + "static/media/mar2.ba91749c.jpg";